<template>
  <PageContent type="full" :compClass="'w-full h-full grid grid-cols-2 gap-4'">
    <div class="flex flex-col bg-gray-200 rounded-md p-4">
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700">
          Email Title
        </label>
        <input
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          type="text"
          v-model="title"
        />
      </div>
      <div class="flex-1">
        <div
          class="w-full h-48 border border-gray-400 rounded-md flex flex-col items-center content-center justify-center"
          v-if="selectedVideos.length == 0"
        >
          <h4 class="text-lg text-gray-500 font-medium">
            No videos currently selected
          </h4>
          <p class="text-gray-400">
            Select videos to the right to add them to this mailing.
          </p>
        </div>
        <div class="flex flex-col space-y-2">
          <div
            class="w-full border border-gray-400 rounded-md p-2 flex flex-row items-center content-center"
            v-for="video in selectedVideos"
            v-bind:key="video.id"
          >
            <div class="px-4">
              <i
                class="fa-regular fa-circle-minus cursor-pointer text-gray-700 hover:text-gray-400"
                v-on:click="videoClicked(video)"
              ></i>
            </div>
            <div class="flex-1 flex flex-row justify-between">
              <div class="flex-1">
                {{ video.title }} <br />
                {{ video.user.name }}
              </div>
              <div>{{ video.created_at | timeAgo }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row justify-end pt-4">
        <button class="px-4 py-2 rounded-md border border-gray-500 mr-4">
          Schedule Email
        </button>
        <button
          class="px-4 py-2  rounded-md text-white"
          :class="{
            'bg-blue-600': selectedVideosIds.length > 0,
            'cursor-not-allowed bg-blue-400': selectedVideosIds.length === 0
          }"
          :disabled="selectedVideosIds.length === 0"
          v-on:click="sendMail"
        >
          Send Email
        </button>
      </div>
    </div>

    <div class="flex flex-col ">
      <div class="sm:hidden">
        <label for="tabs" class="sr-only">Select a tab</label>
        <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
        <select
          id="tabs"
          name="tabs"
          class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
        >
          <option>My Account</option>

          <option>Company</option>

          <option selected>Team Members</option>

          <option>Billing</option>
        </select>
      </div>
      <div class="hidden sm:block bg-white rounded-t-md">
        <div
          class="border-b border-gray-200 flex flex-row justify-between items-center content-center"
        >
          <nav class="-mb-px flex space-x-8 px-4" aria-label="Tabs">
            <button
              class=" group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm focus:outline-none"
              :class="{
                'border-blue-500 text-blue-600 group-hover:text-blue-500':
                  currentTab == 'latest',
                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300':
                  currentTab !== 'latest'
              }"
              v-on:click="currentTab = 'latest'"
            >
              <div class="-ml-0.5 mr-2 h-5 w-5">
                <i class="fa-solid fa-timer "></i>
              </div>
              <span>Latest Media</span>
            </button>

            <button
              class="group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm focus:outline-none"
              :class="{
                'border-blue-500 text-blue-600 group-hover:text-blue-500':
                  currentTab == 'archived',
                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300':
                  currentTab !== 'archived'
              }"
              v-on:click="currentTab = 'archived'"
            >
              <div class="-ml-0.5 mr-2 h-5 w-5">
                <i class="fa-solid fa-box-archive"></i>
              </div>
              <span>Archived Media</span>
            </button>
          </nav>
          <div class="flex flex-row">
            <div class="relative" v-if="currentTab == 'latest'">
              <button
                class="mr-4 focus:outline-none"
                :class="{
                  'text-gray-600': !displaySettingsDropdown,
                  'text-gray-400': displaySettingsDropdown
                }"
                v-on:click="displaySettingsDropdown = !displaySettingsDropdown"
              >
                <i class="fa-solid fa-gear hover:text-gray-400"></i>
              </button>
              <div
                class="fixed inset-0 h-screen w-screen"
                v-if="displaySettingsDropdown"
              >
                <div
                  class="absolute inset-0 opacity-75"
                  v-on:click="
                    displaySettingsDropdown = !displaySettingsDropdown
                  "
                ></div>
              </div>
              <transition
                enter-active-class="transition ease-out duration-100"
                leave-active-class="transition ease-in duration-75"
                enter-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <div
                  class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none p-4 space-y-2"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="menu-button"
                  tabindex="-1"
                  v-if="displaySettingsDropdown"
                >
                  <div class="flex flex-col space-y-1">
                    <label
                      for="hoursOfContent"
                      class="block text-sm font-medium text-gray-700"
                    >
                      Recent
                    </label>
                    <div>
                      <select
                        id="hoursOfContent"
                        name="hoursOfContent"
                        class="max-w-lg block focus:ring-blue-500 focus:border-blue-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                        v-model="hoursOfContent"
                      >
                        <option value="12">12 hours</option>
                        <option value="24">24 hours</option>
                        <option value="36">36 hours</option>
                        <option value="48">48 hours</option>
                        <option value="168">Week</option>
                      </select>
                    </div>
                  </div>
                  <div class="flex flex-col space-y-1">
                    <label
                      for="hideItems"
                      class="block text-sm font-medium text-gray-700"
                    >
                      Hide Previously Sent
                    </label>
                    <div>
                      <Toggle
                        :enabled="hideSentEmails"
                        color="blue"
                        @toggle="toggleHidePreviouslySent"
                      />
                    </div>
                  </div>
                  <button
                    class="bg-gray-500 text-white w-full py-2 rounded-md text-sm focus:outline-none hover:bg-gray-400"
                    v-on:click="setDefaultSettings"
                  >
                    Set Default
                  </button>
                </div>
              </transition>
            </div>
            <button
              class="mr-4 focus:outline-none text-gray-600 hover:text-gray-400"
              v-on:click="refreshVideos"
              v-if="currentTab == 'latest'"
            >
              <i class="fa-solid fa-arrows-rotate"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        class="bg-white p-4 flex flex-row space-x-2"
        v-if="currentTab == 'archived'"
      >
        <input
          type="text"
          name="search_terms"
          id="search_terms"
          class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
          placeholder="search terms"
          v-model="searchQuery"
        />
        <button
          class="px-4 py-2 bg-blue-600 text-white rounded-md focus:outline-none hover:bg-blue-500"
          v-on:click="search"
        >
          Search
        </button>
      </div>
      <div class="flex flex-col space-y-2 bg-gray-50 p-4 rounded-b-md">
        <div
          v-if="!loading"
          class="w-full border border-gray-300 rounded-md p-2 cursor-pointer hover:bg-gray-300 flex flex-row justify-between"
          :class="{
            'border-blue-500 border-2': selectedVideosIds.includes(video.id)
          }"
          v-for="video in fiteredAvailableEmailsList"
          v-bind:key="video.id"
          v-on:click="videoClicked(video)"
        >
          {{ video.title }} <br />
          {{ video.user.name }}
          <div>
            <p
              class="px-2 inline-flex items-center content-center text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800 m-0"
              v-if="video.meta.hasBeenMailed"
            >
              Sent
            </p>
          </div>
        </div>
        <div
          class="bg-gray-50 border border-gray-200 flex items-center content-center justify-center py-24 rounded-md"
          v-if="loading"
        >
          <DotPulse />
        </div>
        <div
          class="bg-gray-50 border border-gray-200 flex items-center content-center justify-center py-24 rounded-md"
          v-if="!loading && fiteredAvailableEmailsList.length == 0"
        >
          No videos available given the current criteria.
        </div>
      </div>
    </div>
  </PageContent>
</template>

<script>
import { EventBus } from "@/utils/events";
import * as Config from "@/config";
import { mapState, mapGetters } from "vuex";
import moment from "moment";

import PageContent from "@/components/PageContent";
import Toggle from "@/components/Toggle";
import DotPulse from "@/components/Loaders/DotPulse";

export default {
  name: "MediaMailer",
  data() {
    return {
      selectedVideosIds: [],
      selectedVideos: [],
      videos: [],

      networks: {},
      title: null,
      hoursAgo: 24,
      loading: false,

      polling: false,

      hoursOfContent: 48,
      hideSentEmails: false,
      displaySettingsDropdown: false,

      currentTab: "latest",
      searchQuery: null
    };
  },
  components: {
    PageContent,
    Toggle,
    DotPulse
  },
  mounted() {
    this.loadVideos();
  },
  computed: {
    fiteredAvailableEmailsList: function() {
      return this.videos.filter(video => {
        if (this.hideSentEmails) {
          if (video.meta.hasBeenMailed) return;
        }
        return video;
      });
    }
  },
  watch: {
    currentTab: function(tab) {
      this.videos = [];
      if (tab == "latest") {
        this.loadVideos();
      }
    },
    hoursOfContent: function() {
      this.loadVideos();
    }
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    async loadVideos() {
      this.loading = true;
      try {
        let res = await this.$http.get(
          Config.apiPath +
            "/api/v2/admin/mail/available-videos?hoursAgo=" +
            this.hoursOfContent
        );
        console.log(res.data);
        this.videos = res.data;
      } catch (e) {}

      this.loading = false;
    },

    refreshVideos() {
      this.loadVideos();
    },

    videoClicked(video) {
      if (this.selectedVideosIds.includes(video.id)) {
        this.selectedVideos = this.selectedVideos.filter(function(item) {
          return item.id !== video.id;
        });
        this.selectedVideosIds.splice(
          this.selectedVideosIds.indexOf(video.id),
          1
        );
        return;
      }
      this.selectedVideosIds.push(video.id);
      this.selectedVideos.push(video);
    },

    sendMail() {
      if (this.title == null) {
        this.$swal(
          "Whoa, wait a minute!",
          "Your mailing doesn't have a title! You better do that!",
          "error"
        );
        return;
      }

      var _this = this;
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to cancel or edit this opperation!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, send the mail!"
      }).then(result => {
        if (result.value) {
          //  only send videos that are selected by admin
          var videosToSend = [];

          for (var i = 0; i < this.videos.length; i++) {
            if (this.videos[i].selected) {
              videosToSend.push(this.videos[i]);
            }
          }

          var data = {
            title: this.title,
            videos: this.selectedVideosIds
          };

          // send mail
          this.$http
            .post(Config.apiPath + "/api/v2/admin/mail/v2/media-mail", data)
            .then(response => {
              console.log(response.data);

              _this.$swal(
                "Sent!",
                "Your mailing is being sent to media clients.",
                "success"
              );
            });
        }
      });
    },
    something() {
      alert("Need to implement sending email");
    },
    setDefaultSettings() {
      alert("Need to implement set default settings.");
    },
    toggleHidePreviouslySent() {
      this.hideSentEmails = !this.hideSentEmails;
    },
    async search() {
      try {
        let res = await this.$http.get(
          Config.apiPath + "/api/v2/admin/videos?search=" + this.searchQuery
        );
        this.videos = res.data.data;
      } catch (e) {}
      alert("This is not fully functional yet.");
    }
  },
  filters: {
    timecode: function(value) {
      if (value !== null) {
        var seconds = Math.floor(value % 60).toString();
        var minutes = Math.floor(value / 60).toString();
        if (seconds.length === 1) {
          seconds = "0" + seconds;
        }
        return minutes + ":" + seconds;
      }
    },
    displayLocalDateTime: function(date) {
      return moment
        .utc(date)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    }
  }
};
</script>

<style scoped></style>
